import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Container,
  Hidden,
  Drawer,
  IconButton,
  useTheme,
} from "@mui/material";
import { Link } from "react-router-dom";

//pages
import NavBarMenu from "./NavBarMenu";
import NavBarSecondaryMenu from "./NavBarSecondaryMenu";

//icons
import { Menu as MenuIcon } from "@mui/icons-material";

//images
import FourCeeLogo from "../../images/4cee/4cee-logo-orange-white.svg";

export default function Header() {
  const theme = useTheme();
  const [drawerIsOpen, setDrawerIsOpen] = useState(false);

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      setDrawerIsOpen(false);
    }

    setDrawerIsOpen(open);
  };

  return (
    <AppBar
      position="static"
      className="MainAppBar"
      style={{
        height: "87px",
      }}
    >
      <Toolbar>
        <Container maxWidth={false}>
          <Link to="/" style={{ float: "left", marginTop: "5px" }}>
            <img alt="4CEE Invoice Gateway" src={FourCeeLogo} className="logo" />
          </Link>
          <Hidden mdDown>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <NavBarMenu propsClass={"navDisplayFlex"} />
            </div>

            <div style={{ marginLeft: "15px" }}>
              <NavBarSecondaryMenu propsClass={"secondaryNavDisplayFlex"} />
            </div>
          </Hidden>
          <Hidden mdUp>
            <React.Fragment>
              <IconButton
                edge="start"
                aria-label="menu"
                onClick={toggleDrawer(true)}
                style={{ float: "right" }}
                size="large"
              >
                <MenuIcon fontSize="large" style={{ color: `white` }} />
              </IconButton>

              <Drawer
                anchor="right"
                open={drawerIsOpen}
                onClose={toggleDrawer(false)}
              >
                <div
                  style={{
                    backgroundColor: theme.palette.darkBackground.main,
                    color: "white",
                  }}
                  className="MainDrawer"
                  onClick={toggleDrawer(true)}
                  onKeyDown={toggleDrawer(true)}
                >
                  <NavBarMenu />
                  <NavBarSecondaryMenu />
                </div>
              </Drawer>
            </React.Fragment>
          </Hidden>
        </Container>
      </Toolbar>
    </AppBar>
  );
}
